import { render } from "./StatusBool.vue?vue&type=template&id=66bb705e"
import script from "./StatusBool.vue?vue&type=script&lang=js"
export * from "./StatusBool.vue?vue&type=script&lang=js"
script.render = render

export default script